import React from "react";
import { createTheme, ThemeProvider, Container } from "@mui/material";
import Link from "@mui/material/Link";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./PayerTemplate.scss";


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1620,
        },
    },
});

const PayerTemplate: React.FC = () => {
    const navigate = useNavigate();
    const clientConfigurations = useSelector(
        (state: any) => state?.registerApp?.configurations
    );
    return (
        <>
            <section className="payer-section">
                <ThemeProvider theme={theme}>
                    <Container maxWidth="xl">
                        <div className="payer-box">
                            <Grid container>
                                <Grid
                                    lg={3}
                                    xs={12}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        pr: { xl: 8, lg: 6 },
                                    }}
                                >
                                    <div className="payer-content">
                                        <h4 className="title-lg">Payer ID’s</h4>
                                        <p>
                                            Crucially, our Provider Directory APIs necessitate the
                                            inclusion of the CHC Payer ID parameter. In the example,
                                            CHCPAYERID should be replaced with the payer’s ID you
                                            wish to access (refer to the table for a complete list
                                            of Sandbox and Production Payer IDs).
                                        </p>
                                    </div>
                                </Grid>
                                <Grid lg={9} xs={12}>
                                    <div className="payer-view">
                                        <div className="payer-grid-view">
                                            <div className="payer-table">
                                                <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                        maxHeight: 500,
                                                        overflowY: "auto",
                                                    }}>
                                                    <Table
                                                        stickyHeader
                                                        sx={{ minWidth: 650 }}
                                                        aria-label="simple table"
                                                    >
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Payer</TableCell>
                                                                <TableCell>Payer ID (Sandbox)</TableCell>
                                                                <TableCell>Payer ID (Production)</TableCell>
                                                                {/* //<TableCell>Payer Code</TableCell> */}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {clientConfigurations && clientConfigurations.length > 0 ? clientConfigurations?.map((row: any) => (
                                                                <TableRow
                                                                    key={row.clientName}
                                                                    sx={{
                                                                        "&:last-child td, &:last-child th": {
                                                                            border: 0,
                                                                        },
                                                                    }}
                                                                >
                                                                    <TableCell component="th" scope="row">
                                                                        <div className="payer-column">
                                                                            <span>
                                                                                <img
                                                                                    src={row.sM_Logo_Path}
                                                                                    alt={row.clientName}
                                                                                />
                                                                            </span>
                                                                            <label>{row.clientName}</label>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        onClick={() =>
                                                                            navigate(
                                                                                "/providerdirectory/location-api/location",
                                                                                {
                                                                                    state: {
                                                                                        route: row.clientName,
                                                                                    },
                                                                                }
                                                                            )
                                                                        }
                                                                    >
                                                                        <Link>
                                                                            {row.payerID_Stage?.toLowerCase()}
                                                                            <CallMadeOutlinedIcon />
                                                                        </Link>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        onClick={() =>
                                                                            navigate(
                                                                                "/providerdirectory/location-api/location/prod",
                                                                                {
                                                                                    state: { route: row.clientName },
                                                                                }
                                                                            )
                                                                        }
                                                                    >
                                                                        <Link>
                                                                            {row.payerID_Prod?.toLowerCase()}
                                                                            <CallMadeOutlinedIcon />
                                                                        </Link>
                                                                    </TableCell>
                                                                    {/* <TableCell>{row.payerCode || "Not Available"}</TableCell>  */}
                                                                </TableRow>
                                                            )) : <TableCell>No payer found. </TableCell>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </ThemeProvider>
            </section>
        </>
    );
};

export default PayerTemplate;
